export const environment = {
  production: true,
  baseApi: "https://api.ohmymenu.com",
  baseApp: "https://menu.ohmymenu.com/home",
  bucket: "com-ohmymenu-admin",
  release: "0.2.35",
  name: "production",
  firebase: {
    apiKey: "AIzaSyBZM3lyTqD7CJnFeXaGe2E-zaXK3Ahtq0M",
    authDomain: "com-ohmymenu.firebaseapp.com",
    databaseURL: "https://com-ohmymenu.firebaseio.com",
    projectId: "com-ohmymenu",
    storageBucket: "com-ohmymenu.appspot.com",
    messagingSenderId: "229737233171",
    appId: "1:229737233171:web:03f0ca38027a7c543838e6",
    measurementId: "G-MWE8Z11FE3",
  },
  stripeApiKey: "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",
  stripePublishableKey: "pk_live_51Ict0KITe39ZnbibKQPhOa5k0ghlS7hXmGM3L2rDJv4wrwWpfzIp4MHpd5eebMHjUtTybQ7WZthnJC6l0QJhbuXw00cS2T7upd",
  googleClientId: "229737233171-8v592h6as057k4dqo07vt1257t5upi60.apps.googleusercontent.com",
};
